import React, { useState } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';

const ImageCrop = ({ image, setNewImage, open, handleClose }) => {
    const [src, setSrc] = useState(image);
    const [crop, setCrop] = useState({
        unit: '%',
        x: 25,
        y: 25,
        width: 50,
        height: 50
    });

    const onCropComplete = (newPhotoImg) => {
        return new Promise((resolve, reject) => {

            const image = document.createElement('img');
            image.src = newPhotoImg;

            image.onload = () => {
                const canvas = document.createElement('canvas');
                const scaleX = image.naturalWidth / image.width;
                const scaleY = image.naturalHeight / image.height;
                canvas.width = crop.width;
                canvas.height = crop.height;
                const ctx = canvas.getContext('2d');

                ctx.drawImage(
                    image,
                    crop.x * scaleX,
                    crop.y * scaleY,
                    crop.width * scaleX,
                    crop.height * scaleY,
                    0,
                    0,
                    crop.width,
                    crop.height
                );

                canvas.toBlob((blob) => {
                    if (!blob) {
                        console.error('Canvas is empty');
                        reject(new Error('Canvas is empty'));
                        return;
                    }
                    const croppedURL = window.URL.createObjectURL(blob);
                    resolve(croppedURL);
                }, 'image/jpeg');
            };

            image.onerror = (error) => {
                reject(error);
            };
        });
    };

    return (
        <Dialog open={open} onClose={handleClose} fullScreen>
            <DialogTitle>Resmi Kırp</DialogTitle>
            <DialogContent>
                <div>
                    <ReactCrop
                        crop={crop}
                        onChange={(crop, percentCrop) => setCrop(crop)}
                    >
                        <img
                            src={src}
                            alt="Crop"
                        />
                    </ReactCrop>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    iptal et
                </Button>
                <Button
                    color="primary"
                    onClick={() => {
                        onCropComplete(src).then((croppedImage) => {
                            setNewImage(croppedImage);
                            handleClose();
                        });
                    }}
                >
                    tamamla
                </Button>
            </DialogActions>
        </Dialog >
    );
};

export default ImageCrop;
